import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _InnovationMargauxMotinRoot = styled("section")(() => {
  return css`
    .innovation-product-list-wrapper {
      transform: translateX(7%);
      justify-content: space-between;
      flex-wrap: nowrap;
      
      @media (min-width: 1040px) {
        gap: 0;
        transform: translateX(2%);
      }
    }

    .landing-innovations__title {
      max-width: 408px;
      @media ${responsiveMap.mobile} {
        max-width: 246px; 
      }
    }
  `;
});
